module.exports = __webpack_public_path__ + "static/media/video-thumbnail-4.32eaf505.png";